var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgUploadIcon = function SvgUploadIcon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "1em",
    height: "1em",
    viewBox: "0 0 45 57",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.333 0C3.283 0 0 3.377 0 7.543v32.914C0 44.623 3.284 48 7.334 48h7.011v-4.115H7.333C5.493 43.885 4 42.35 4 40.457V7.543c0-1.894 1.492-3.429 3.333-3.429h8.458c.07 0 .14.002.209.007v8.907c0 4.166 3.283 7.543 7.333 7.543h8.66c.004.071.007.143.007.215v5.06h4v-5.06c0-2-.772-3.919-2.148-5.333L20.976 2.21A7.231 7.231 0 0 0 15.791 0H7.333ZM20 13.029V7.024l9.171 9.433h-5.838c-1.84 0-3.333-1.535-3.333-3.428Z",
    fill: "currentColor"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M24.7 47.2a4.9 4.9 0 0 1-.516-9.772 5.601 5.601 0 0 1 10.854-2.768 6.302 6.302 0 0 1 6.805 8.35A6.3 6.3 0 0 1 35.9 47.2h-3.5v-5.022l1.81 1.81a1.4 1.4 0 0 0 1.98-1.98l-4.2-4.2a1.4 1.4 0 0 0-1.98 0l-4.2 4.2a1.4 1.4 0 0 0 1.98 1.98l1.81-1.808v5.02h-4.9Z",
    fill: "currentColor"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M29.6 47.2h2.8v7a1.4 1.4 0 0 1-2.8 0v-7Z",
    fill: "#B0B0B0"
  })));
};
export default SvgUploadIcon;